/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { scenarioItemSuggestionSchema } from './scenarioItemSuggestionSchema';

export const aiSuggestionsPageSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(scenarioItemSuggestionSchema);
  },
  generatedAt: z.iso.datetime().nullish(),
  pendingCount: z.int(),
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
  skippedCount: z.int(),
});
